<div class="template-row w-full h-full relative"
     [ngStyle]="backgroundStyle"
     [id]="row.elementId"
     [style.background-image]="row.backgroundImage ? 'url(' + row.backgroundImage + ')' : null"
     [style.background-position]="row.backgroundImage ? 'center' : null"
     [style.background-repeat]="row.backgroundImage ? 'no-repeat' : null">
    <div [id]="'template-row-' + rowIndex"
         class="grid grid-cols-1 relative"
         [ngClass]="rowClasses">
        <ng-content></ng-content>
        <div *ngIf="!row.components?.length && editMode"
             class="my-4 px-32 py-5 w-full flex justify-center content-center col-span-full md:col-span-full !bg-black/20 text-black/30 cursor-pointer hover:bg-black/20"
             (click)="onHuskClicked()">
            <div class="font-bold">Click to add components</div>
        </div>
    </div>
    <div *ngIf="isHighlighted"
         class="absolute top-0 left-3 w-24 h-12 px-1 py-3 content-['Row'] text-xs text-center text-white z-10 bg-indigo-900">
        {{ row.label || "Row " + (rowIndex + 1) }}
    </div>
</div>
